import type { DependentRelation } from '../../../core/fundPolicy/schema';
import type { DependentStatus } from '../domain/dependent/schema';

/**
 * Arabic wording for the dependant enums, in one place.
 *
 * `Record` rather than a lookup function with a fallback: adding a relation to
 * the policy then fails to compile here, instead of silently rendering the raw
 * enum value to an employee.
 */

export const RELATION_LABELS_AR: Readonly<Record<DependentRelation, string>> = {
  spouse: 'الزوج/الزوجة',
  son: 'ابن',
  daughter: 'ابنة',
  father: 'الأب',
  mother: 'الأم',
};

export const STATUS_LABELS_AR: Readonly<Record<DependentStatus, string>> = {
  pending_documents: 'بانتظار الوثائق',
  under_review: 'قيد المراجعة',
  active: 'مشمول',
  rejected: 'مرفوض',
  aged_out: 'تجاوز السن',
};

export type StatusTone = 'neutral' | 'success' | 'warning' | 'error' | 'info';

export const STATUS_TONES: Readonly<Record<DependentStatus, StatusTone>> = {
  pending_documents: 'warning',
  under_review: 'info',
  active: 'success',
  rejected: 'error',
  aged_out: 'neutral',
};

/**
 * Whether the employee may still change this dependant.
 *
 * `pending_documents` alone, because that is what `firestore.rules` permits.
 * This said `under_review` as well, under a comment claiming it mirrored the
 * rules — so the screen would have offered an edit the server refuses. The
 * rule is the boundary; this follows it.
 *
 * Editing is closed per dependant, not for the whole list: one approved child
 * locks while a sibling still being entered stays open.
 */
export function isEditable(status: DependentStatus): boolean {
  return status === 'pending_documents';
}
